(() => {
  if (window.__MF_REMOVE_PHYSICAL_SIZE_UI__) return;
  window.__MF_REMOVE_PHYSICAL_SIZE_UI__ = true;

  const selector = '[data-mf-sizebox], .mf-designer-sizebox';

  function removePhysicalSizeUi(root = document) {
    if (root instanceof Element && root.matches?.(selector)) {
      root.remove();
      return;
    }
    root.querySelectorAll?.(selector).forEach(el => el.remove());
    document.getElementById('mf-designer-size-style')?.remove();
  }

  removePhysicalSizeUi();

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node instanceof Element) removePhysicalSizeUi(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
